import { Navigate } from 'react-router-dom';
import { useRegion } from '../../hooks/useRegion';

interface RegionGuardProps {
  /** When true, the route only applies to EU installations. */
  euOnly?: boolean;
  children: JSX.Element;
}

/**
 * Route guard that hides jurisdiction-specific pages on installations whose
 * platform region does not match. Unlike ModuleGuard this is NOT a permission
 * check — an EU-only page (EU AI Act, GDPR) makes no sense on a non-EU box, so
 * even platform admins are redirected. Renders children while the region is
 * still loading to avoid a redirect flash.
 */
export default function RegionGuard({ euOnly, children }: RegionGuardProps) {
  const { isEU, isLoading } = useRegion();

  if (euOnly && !isEU && !isLoading) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
